var render = function (_h,_vm) {var _c=_vm._c;return _c('ul',{style:({listStyleType: _vm.props.attributes.liststyletype})},_vm._l((_vm.props.attributes.text),function(item,i){return _c('li',{directives:[{name:"markdown",rawName:"v-markdown",value:(item),expression:"item"}],key:i})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }